<template>
  <div style="width:100%">
    <div style="display: flex; flex-flow: row wrap; width: 100%">
      <div style="width:100%; display: flex; flex-flow: column nowrap;" ref="DivCanvas">
        <VUEComponenteGraficoCronologiaAcc :WidthGrafico="GrandezzaCanvas.Width" 
                                           :HeightGrafico="Altezza"
                                           :Dati="ObjGrafico"
                                           :Repaint="Repaint"
                                           :RepaintDeep="RepaintDeep"
                                           :LivelliAllarme="LivelliAllarme"
                                           :TipoAmpiezza="Ampiezza"/>
      </div>
    </div>
  </div>

</template>

<script>
import VUEComponenteGraficoCronologiaAcc from './VUEComponenteGraficoCronologiaAcc.vue'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { COLORI_PANTONE } from '@/SystemInformation'

export default 
{
  data()
  {
   return {
            ColoriPantone            : COLORI_PANTONE,
            GrandezzaCanvas          : {
                                         Width  : 0,
                                         Height : 0
                                       },
            ObjGrafico               : {},
            Repaint                  : 0,
            RepaintDeep              : 0,
          }
  },

  props : ['ObjDal', 'ObjAl', 'UdmX', 'ListaEventi', 'Stacking', 'Ampiezza', 'GraficiChange', 'LivelliAllarme', 'Catena', 'Altezza', 'AsseY', 'GetDatiPDF', 'ParametriPDF'],
  emits : ['EsportaPDFGrafico'],
  components:
  {
    VUEComponenteGraficoCronologiaAcc,
  },

  methods :
  {
    CalcolaGrandezzaDivCanvas()
    {
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = this.$refs.DivCanvas.clientHeight
      this.Repaint++
    },

    ChangeAmpiezza()
    {
      // this.ObjGrafico.Punti = []
      // for (let i = 0; i < this.ListaEventi.length; i++)
      // {
      //   let Evento = this.ListaEventi[i]
      //   let ObjModuloPrincipale = {}
      //   ObjModuloPrincipale.Modulo = -1
      //   ObjModuloPrincipale.Profondita = -1
      //   let MaxAmpiezza = 0
      //   let Frequenza = Evento.Moduli.length

      //   for (let j = 0; j < Evento.Moduli.length; j++)
      //   {
      //     let Modulo = Evento.Moduli[j]
      //     let Max = Math.max(Math.abs(Modulo.MaxAccX - Modulo.MinAccX),
      //                        Math.abs(Modulo.MaxAccY - Modulo.MinAccY),
      //                        Math.abs(Modulo.MaxAccZ - Modulo.MinAccZ))

      //     if (MaxAmpiezza < Max)
      //     {
      //       ObjModuloPrincipale.Modulo = Modulo.Modulo
      //       ObjModuloPrincipale.Profondita = Modulo.Profondita
      //       MaxAmpiezza = Max
      //     }
      //   }

      //   Evento.MaxAmpiezza = MaxAmpiezza
      //   Evento.ModuloPrincipale = ObjModuloPrincipale
      //   Evento.Frequenza = Frequenza
      //   this.ObjGrafico.Punti.push(Evento)
      // }

      this.RepaintDeep++
    },

    
    EsportaComePDF()
    {
      let IdModulo = -1
      this.$emit('EsportaPDFGrafico', IdModulo)
    },

    GetGraficiPDF()
    {
      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []
      
      let ModuloPDF = -1

      this.ObjPDF.PDFModulo.push(ModuloPDF)
      this.ObjPDF.PDFObjDatiGrafici.push(TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico))


      // let ObjDatiGrafici = TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico)
      // let ObjModulo = {Id : -1, Profondita : -1, DatiGrafici : ObjDatiGrafici}
      // this.ObjPDF.ModuliConsiderati.push(ObjModulo)
    },

    GetStartConfig()
    {
      let MinProfondita = 999
      let MaxProfondita = -999
      
      for (let i = 0; i < this.Catena.Sensori.length; i++)
      {
        if (Number(this.Catena.Sensori[i].Profondita) < MinProfondita)
          MinProfondita = Number(this.Catena.Sensori[i].Profondita)
        if (Number(this.Catena.Sensori[i].Profondita) > MaxProfondita)
          MaxProfondita = Number(this.Catena.Sensori[i].Profondita)
      }

      this.ObjGrafico.AxisX      = {}
      this.ObjGrafico.AxisY      = {}
      this.ObjGrafico.ListaPunti = this.ListaEventi
      this.ObjGrafico.Generale   = {}

      this.MisureAsseY.Min = MinProfondita
      this.MisureAsseY.Max = MaxProfondita
      this.MisureAsseY.Udm = 10
      this.ChangeAxes()
    },

    ChangeAxes()
    {
      let AsseX = {}
      AsseX = {}
      AsseX.Min = new Date(this.ObjDal.Data + ' 00:00:00').valueOf()
      let DataAl = TZDateFunct.ChangeDate(new Date(this.ObjAl.Data + ' 00:00:00'), 'day', 1)
      AsseX.Max = DataAl.valueOf()
      AsseX.Udm = this.UdmX * 3600 * 1000
      this.ObjGrafico.AxisX.Min  = AsseX.Min
      this.ObjGrafico.AxisX.Max  = AsseX.Max
      this.ObjGrafico.AxisX.Udm  = AsseX.Udm
      
      this.ObjGrafico.AxisY.Min  = this.MisureAsseY.Min
      this.ObjGrafico.AxisY.Max  = this.MisureAsseY.Max
      this.ObjGrafico.AxisY.Udm  = this.MisureAsseY.Udm
    }
  },
  
  computed:
  {
    MisureAsseY :
    {
      get()
      {
        return this.AsseY
      }
    },
  
    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    }
  },
  
  watch:
  {
    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    }, 

    GraficiChange:
    {
      handler()
      {
        this.ChangeAxes()
        this.ChangeAmpiezza()
        this.ObjGrafico.ListaPunti = this.ListaEventi
        this.RepaintDeep++
      }
    },

    Ampiezza:
    {
      handler()
      {
        this.ChangeAmpiezza()
      }
    },
  },

  beforeMount()
  {
    this.GetStartConfig()
    this.ChangeAmpiezza()
  },
  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>